import React from "react";
import {
  ShieldCheck,
  ChefHat,
  Star,
  Award,
  Target,
  CheckCircle2,
} from "lucide-react";
import { REQUIREMENTS, COMMERCIAL_KITCHEN } from "../mock/data";

const iconMap = { ShieldCheck, ChefHat, Star, Award, Target };

const Requirements = () => {
  return (
    <section id="requirements" className="relative py-24 lg:py-32 bg-[#0E0E13] overflow-hidden">
      <div className="absolute inset-0 stripe-overlay opacity-50" />

      <div className="relative max-w-[1480px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left: editorial */}
          <div className="lg:col-span-5">
            <div className="sticky top-28">
              <div className="inline-flex items-center gap-2 mb-6">
                <CheckCircle2 className="w-4 h-4 text-[#14E0BF]" />
                <span className="font-mono text-[11px] text-[#14E0BF] uppercase tracking-[0.2em]">
                  Eligibility
                </span>
              </div>
              <h2 className="text-white mb-8">
                <span className="font-serif-display italic text-5xl lg:text-7xl leading-[0.95] block">
                  Who we work
                </span>
                <span className="font-display text-5xl lg:text-7xl leading-[0.95] block text-[#14E0BF] mt-1">
                  with.
                </span>
              </h2>
              <p className="text-white/70 text-base lg:text-lg leading-relaxed mb-8 max-w-[440px]">
                We&rsquo;re selective – because our partners&rsquo; ratings are our ratings. If you tick all five boxes, we&rsquo;ll talk. If you tick four, we still want to hear from you.
              </p>
              <div className="relative overflow-hidden rounded-3xl aspect-[4/5] border border-white/10">
                <img
                  src={COMMERCIAL_KITCHEN}
                  alt="Commercial kitchen"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0E0E13] via-transparent to-transparent" />
                <div className="absolute bottom-5 left-5 right-5 bg-[#14141B]/95 backdrop-blur-md rounded-2xl p-5 border border-white/10">
                  <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/45 mb-1">
                    Currently active partners
                  </div>
                  <div className="font-display text-3xl text-white">5 kitchens</div>
                  <div className="text-white/55 text-sm mt-1">and expanding aggressively across the UK</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: list */}
          <div className="lg:col-span-7">
            <div className="space-y-3">
              {REQUIREMENTS.map((item) => {
                const Icon = iconMap[item.icon];
                return (
                  <div
                    key={item.id}
                    className="group relative bg-[#14141B] border border-white/10 rounded-2xl p-6 lg:p-7 hover:border-[#14E0BF]/40 hover:bg-[#1C1C25] transition-all duration-300"
                  >
                    <div className="flex items-start gap-5">
                      <div className="shrink-0 w-12 h-12 lg:w-14 lg:h-14 rounded-xl bg-[#14E0BF]/10 border border-[#14E0BF]/30 flex items-center justify-center group-hover:bg-[#14E0BF] transition-colors duration-300">
                        <Icon
                          className="w-6 h-6 lg:w-7 lg:h-7 text-[#14E0BF] group-hover:text-[#07070A] transition-colors duration-300"
                          strokeWidth={2}
                        />
                      </div>
                      <div className="flex-1">
                        <div className="flex items-baseline gap-3 mb-1">
                          <span className="font-mono text-[11px] text-white/35">
                            0{item.id}
                          </span>
                          <h3 className="font-display text-white text-lg lg:text-xl uppercase">
                            {item.title}
                          </h3>
                        </div>
                        <p className="text-white/60 text-sm lg:text-base leading-relaxed">
                          {item.subtitle}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* CTA card */}
            <div className="mt-6 relative overflow-hidden rounded-2xl bg-[#14E0BF] p-6 lg:p-8">
              <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
                <div>
                  <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#07070A]/65 mb-2">
                    Not sure if you qualify?
                  </div>
                  <p className="font-display text-[#07070A] text-2xl lg:text-3xl uppercase leading-tight max-w-[440px]">
                    Apply anyway. We&rsquo;ll tell you in 48 hours.
                  </p>
                </div>
                <a
                  href="#journey"
                  className="btn-pill inline-flex items-center gap-2 bg-[#07070A] text-white font-display text-[12px] uppercase tracking-wider px-6 py-3.5 rounded-full whitespace-nowrap"
                >
                  Start application →
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Requirements;
